exports.baseURL = "https://admin.butterlive.co.in/";
exports.key = "ZUH@eXb246w*n#FXe#TsMVCpikhEBgbk";
exports.projectName = "Butter Live"
